import React from 'react';
import { Box, Typography, color } from '@kistech/kis-ui';
import { MediaTypes } from '../../../types';

interface VideoProps {
  videoType?: string;
}

export const Requirements = (props: VideoProps) => (
  <>
    <Box margin="4 0" style={{ whiteSpace: 'pre-wrap' }}>
      <Typography size={12} weight={600}>
        Recommended Resolution
      </Typography>
      <Typography size={12}>
        {props.videoType === MediaTypes.ATTRACT_VIDEO
          ? 'Landscape: 1720px by 880px \nPortrait: 880px by 1705px'
          : 'Landscape: 1920px by 1080px \nPortrait: 1080px by 1920px'}
      </Typography>
    </Box>
    <Box margin="4 0 6">
      <Typography size={12} weight={600} color={color.RED}>
        Requirements
      </Typography>
      <Typography size={12}>
        File format must be .mp4 or .mov
        <br />
        Maximum file size allowed is 100MB
      </Typography>
    </Box>
  </>
);
